import { useRouter } from 'expo-router';
import { StyleProp, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { isIos } from 'utils/environment';

/**
 * Offsets CardModal's iOS cold-deeplink wrapper margin from outside the component.
 *
 * CardModal adds `marginTop: top` to its iOS root when `canGoBack()` is false.
 * That margin is on CardModal's outer wrapper, so inner children cannot cancel it.
 * A parent shell with the inverse margin restores the intended layout for PDP only.
 */
export function useProductDetailCardModalStyles(): StyleProp<ViewStyle> | undefined {
  const router = useRouter();
  const { top } = useSafeAreaInsets();

  if (!isIos || router.canGoBack() || top <= 0) {
    return undefined;
  }

  return { marginTop: -top };
}
